<template>
    <stepper-template 
        :nbStep="nbStep" 
        :currentStepNumber="currentStepNumber">

        <!-- Step header -->
        <template slot="header">
            <header class="step-header-container flex-level">
                <div class="dinlineb valign-middle ml-3">
                    <icon-svg icon-name="sellsy" :width="118" :height="28" viewBox="0 0 118 28" class="m-0 mb-2 secondary-blue"><icon-sellsy-text/></icon-svg>
                    <router-link v-if="previousStep" :to="{name: previousStep, query: { lang: $route.query.lang }}" class="grey-link semibold flex-level">
                        <i class="icon-arrow-back mr-1"></i>
                        <span>{{ $l10n.__("Page précédente") }}</span>          
                    </router-link>
                    <a v-else href="https://go.sellsy.com" class="grey-link semibold flex-level">
                        <i class="icon-arrow-back mr-1"></i>
                        <span>{{ $l10n.__("Retourner sur go.sellsy.com") }}</span>
                    </a>
                </div>
                <transition name="fade" >
                    <lang-selector
                        v-if="currentStepNumber === 1"
                        class="flex-item-right"
                        :value="countrySelected"
                        :availableLanguages="['en', 'fr']">
                    </lang-selector>
                </transition>
            </header>
        </template>

    </stepper-template>
</template>

<script>

import LangSelector from 'vcomponents/utilities/LangSelector.vue'
import StepperTemplate from 'vcomponents/utilities/StepperTemplate.vue';
import StepperMixin from 'mixins/StepperMixins';
import OnboardingTrialStore from 'stores/onboarding/trial/store'
import { createNamespacedHelpers } from 'vuex'
import { VueReCaptcha }                 from 'vue-recaptcha-v3';
import Vue                              from 'vue';
import { isDesktop } from 'utils/global';
import LocalStorage from 'Core/commons/LocalStorage';
import Store from 'Services/Store';
import IconSvg from 'vcomponents/icons/IconSvg.vue';
import IconSellsyText from 'vcomponents/icons/IconSvgLogoSellsyText.vue';

const namespace = 'onboardingTrial'
const { mapGetters }  = createNamespacedHelpers(namespace)
const { mapState: mapStateSystem }  = createNamespacedHelpers('system')

/**
 * user can't skip step
 */
const guardIsSkipStep = (to) => {
    const stepper = new LocalStorage(namespace, 'stepper');
    if(!stepper.get()) stepper.set({currentStep: 0});
    return Math.abs(stepper.get().currentStep - to.path.slice(-1)) > 1
}

/**
 * user don't must be logged
 */
const guardIslogged = () => {
    const user = Store.get('user')
    return user.id
}

/**
 * query param lang must be defined
 */
const guardIsNotDefineLang = (to) => !to.query.lang

/**
 * query param lang must be available
 */
const guardIsNotAvailableLang = (to) => {
    const availableLang = Store.get('system').availableLanguages.map(({id}) => id);
    return !availableLang.includes(to.query.lang);
}

export default {
    name: 'OnboardingTrial',
    mixins: [StepperMixin],
    data() {
        return {
            namespaceLocalStorage: namespace,
            countrySelected: null,
            nbStep: 2
        }
    },
    beforeRouteEnter(to, from, next) {

        if (guardIslogged()) {
            window.location.href = '/'
        } else if (!isDesktop()) {
            window.location.href = "https://go.sellsy.com/fr/demande-de-rendez-vous/"
        } else if (guardIsSkipStep(to)) {
            const currentStep = new LocalStorage(namespace, 'stepper').get().currentStep
            const safeStep = currentStep !== 0 ? currentStep : 1
            window.location.href = `/onboarding/trial/step${safeStep}`
        } else if (guardIsNotDefineLang(to)) {
            const langStorage = new LocalStorage(namespace, 'lang').get()?.lang || 'fr';
            to.query.lang = langStorage;
            const queryStringParameters = Object.keys(to.query).map(key => key + '=' + to.query[key]).join('&');
            window.location.href = `${to.path}?${queryStringParameters}`;
        } else if (guardIsNotAvailableLang(to)) {
            to.query.lang = 'fr';
            next({ path: to.path, query: to.query });
        } else {
            next();
        }
    },
    created() {

        if (this.reCaptchav3.isEnabled) Vue.use(VueReCaptcha, { siteKey: this.reCaptchav3.siteKey });

        this.countrySelected = this.currentInterfaceLangLocale

        this.$store.registerModule(namespace, OnboardingTrialStore)

        this.createStateInLocalStorage()
        this.updateCurrentLangInStorage(this.$route.query.lang);
    },
    computed: {
        ...mapStateSystem([
            'availableLanguages',
            'reCaptchav3'
        ]),
        ...mapGetters([
            'finalForm'
        ]),
        /**
         * Returns the locale of the interface language passed in the request params, by default "en_US.utf8"
         */
        currentInterfaceLangLocale() {
            const lang = this.$route.query.lang;
            return this.availableLanguages.find(({id}) => id === lang)?.locale || 'en_US.utf8';
        }
    },
    beforeDestroy(){
        this.$store.unregisterModule(namespace);
    },
    components: {
        LangSelector,
        StepperTemplate,
        IconSvg,
        IconSellsyText
    }
}
</script>
